import { Gauge } from '@ant-design/plots'
import moment from 'moment'
import { TSavingsResponce } from '../types'
import '../styles.scss'
import { ThreeDotsMenu } from '../../../components/ThreeDotsMenu'
import ExpectedSavingMenu from './Menu'
import { currencyFormatter } from '../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { TOOLTIP } from '../../../constants'
import { ReactComponent as WarningIcon } from 'assets/svg/WarningIcon.svg'
import { GaugeConfig } from '@ant-design/plots/es/components/gauge'
import cn from 'classnames'
import { useDashboardFilterContext } from '../Providers/DashboardFilterContendProvider'

export const ExpectedSavingsChart = ({ data }: { data: TSavingsResponce }) => {
  const {
    state: { canSeeExpectedSavingsMenu }
  } = useDashboardFilterContext()
  const isNoDataAvailable =
    data.target_sum === null && !Number(data.total_expected_savings)
  const config = {
    gaugeStyle: {
      lineCap: 'round',
      stroke: isNoDataAvailable ? '#E9EEF7' : '#AABFEB'
    },
    percent: isNoDataAvailable ? 100 : +data?.progress,
    radius: 0.75,
    range: {
      color: isNoDataAvailable
        ? '#E9EEF7'
        : +data?.progress >= 1 || +data?.progress === 100
        ? '#508700'
        : data?.progress === 0
        ? '#D0DEF5'
        : '#5B8FCE',
      radius: '20%',
      width: 18
    },
    startAngle: Math.PI / 1.25,
    endAngle: 2.2 * Math.PI,
    indicator: undefined,
    statistic: {
      title: {
        offsetY: -36,
        style: {
          fontFamily: 'Open Sans',
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '32px',
          color: '#103861',
          marginTop: '-50px'
        },
        formatter: () =>
          `$${
            data?.total_expected_savings
              ? currencyFormatter(data?.total_expected_savings)
              : 0
          }`
      },
      content: {
        style: {
          marginTop: '-50px',
          fontWeight: 600,
          fontSize: '20px',
          lineHeight: '28px',
          color:
            +data?.progress >= 1 || +data?.progress === 100
              ? '#508700'
              : '#407EC9'
        },
        formatter: () => {
          if (data.target_sum === null || isNoDataAvailable) {
            return ''
          }
          const number = +data?.progress === 100 ? 100 : data?.progress * 100
          if (typeof number === 'number') {
            return `${parseFloat(number.toFixed(1))}%`
          }
          return '0%'
        }
      }
    }
  }

  return (
    <div className="charts_actual-savings_chart-container">
      <div className="row space-between align-start">
        <div className="charts_titles">
          <div className="charts_title row align-baseline gap-12">
            Expected savings{' '}
            {data?.inaccurate_data_warning && (
              <Tooltip title={TOOLTIP.EXPECTED_SAVINGS_TOOLTIP}>
                <div className="charts_title__icon row align-center justify-center">
                  <WarningIcon />
                </div>
              </Tooltip>
            )}
          </div>
          <div className="charts_subtitle">
            01/01/{moment().format('YYYY')} - 12/31/{moment().format('YYYY')}
          </div>
        </div>
        {canSeeExpectedSavingsMenu && (
          <ThreeDotsMenu className="actual-saving-menu">
            <ExpectedSavingMenu />
          </ThreeDotsMenu>
        )}
      </div>
      <div className="charts_actual-savings_chart-inner">
        <Gauge
          {...(config as GaugeConfig)}
          className="charts_actual-savings_chart"
        />
        <div className="charts_actual-savings">
          <div
            className={cn('charts_actual-savings_start', {
              'not-available': data.target_sum === null
            })}
            data-testid="actualSavingsStartLabel"
          >
            {isNoDataAvailable ? '' : '$0'}
          </div>
          <div
            className={cn('charts_actual-savings_end', {
              'not-available': data.target_sum === null
            })}
            data-testid="actualSavingsEndLabel"
          >
            {data.target_sum === null
              ? ''
              : +data?.target_sum >= 0
              ? '$' + currencyFormatter(data?.target_sum)
              : '-'}
          </div>
        </div>
      </div>
    </div>
  )
}
